"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exchangeRefreshToken = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var jwt_handler_1 = require("../jwt-handler");
var location_handler_1 = require("../location-handler");
var exchangeRefreshToken = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var authTokenRequest, basePath, token, refreshToken, axiosConfig, res, e_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                authTokenRequest = {};
                basePath = (0, location_handler_1.getCurrentEnvBaseApi)({ prefixUri: '/rsp-user-api/api' });
                token = jwt_handler_1.JWTHandler.getCookie('rentspreeUserToken');
                refreshToken = (0, get_1.default)(token, 'refresh_token');
                return [4, jwt_handler_1.JWTHandler.getAxiosConfig()];
            case 1:
                axiosConfig = _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4, axios_1.default.post("".concat(basePath, "/v2/token"), {
                        refresh_token: refreshToken,
                        grant_type: 'refresh_token',
                    }, axiosConfig)];
            case 3:
                res = _a.sent();
                authTokenRequest = res.data;
                return [3, 5];
            case 4:
                e_1 = _a.sent();
                console.error(e_1);
                return [3, 5];
            case 5: return [2, authTokenRequest];
        }
    });
}); };
exports.exchangeRefreshToken = exchangeRefreshToken;
//# sourceMappingURL=exchange-refresh-token.js.map